import React from 'react'
import styles from './avatar.styles'
import injectSheet from 'react-jss'
import Section from '../../../shared/section/section'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import Button from 'pobble-components/dist/button'
import Description from '../../../shared/description/description'
import FormFile from 'pobble-components/dist/form-elements/form-file'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const Avatar = ({ classes, pending, name, avatar, id, onRemove, onChange }) => (
  <Section pending={pending}>
    <div className={classes.container}>
      <PobbleAvatar avatar={avatar} name={name} className={classes.avatar} />
      <div>
        <div className={classes.actions}>
          <FormFile accept=".jpg,.png" onChange={onChange}>
            <Button span tall wide secondary className={classes.button}>
              Upload avatar
            </Button>
          </FormFile>
          {avatar && (
            <Button
              simple
              tall
              action={() =>
                openConfirmationDialog({
                  bodyText: `Are you sure you want to remove your current avatar?`,
                  confirmText: 'Yes',
                  action: () => onRemove(id)
                })
              }>
              Remove
            </Button>
          )}
        </div>
        <Description>
          Your avatar shows up where you comment and in team sections. You can
          upload images up to 10mb.
        </Description>
      </div>
    </div>
  </Section>
)

export default injectSheet(styles)(Avatar)
